import React, { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { AddPatientComponent } from './View';
import Loader from '../../../components/Loader';
import { PERMISSION } from '../../../components/investigation/share/user_roles';
import { HOSPITAL_PATIENT, ROUTE_401, SEARCH_PATIENT_OPTIONS_ROUTE } from '../../../routes/urls';
import { updatePatientAction, savePatientAction } from '../../../redux/actions/patientsActions';
import { usePrevious } from '../../../hooks';
 // Assuming you have a Loader component defined somewhere

interface Props {
    investigations: any; // Replace 'any' with the appropriate type
    patients: any; // Replace 'any' with the appropriate type
    isLoading: boolean; // Assuming you have 'isLoading' defined somewhere
}

export function AddPatient(props: Props) {
    const [isLoading, setIsLoading] = useState(false);
    const [currentInvestigation, setCurrentInvestigation] = useState<any>({});
    const [patientsInvestigation, setPatientsInvestigation] = useState([]);
    const [addedPatient, setAddedPatient] = useState(false);
    const { uuidPatient } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();

    const patient = useMemo(() => {
        return uuidPatient &&
            props.investigations.data &&
            props.patients.data
            ? props.patients.data[props.investigations.currentInvestigation.uuid].find(
                (pat: any) => pat.uuid === uuidPatient
            )
            : null;
    }, [uuidPatient,props.investigations.data, props.patients.data] );

    // New patients are always encrypted with v2. When editing, keep the patient's
    // existing scheme — v1 patients stay v1 (no migration), v2 patients stay v2.
    const useV2Encryption = useMemo(() => {
        return patient ? patient.encScheme === 'v2' : true;
    }, [patient]);
        
    function callbackGoToPatient(uuidPatient:string){
        console.log("callbackGoToPatient", uuidPatient);
        const url = HOSPITAL_PATIENT.replace(":uuidPatient", uuidPatient);
        history.push(url)
    }

    function callbackGoToAppointment(uuidPatient:string){
        console.log("callbackGoToAppointment", uuidPatient);
        const url = SEARCH_PATIENT_OPTIONS_ROUTE.replace(":action", "appointment").replace(":uuidPatient", uuidPatient);
        history.push(url)
    }
    
    useEffect(() => {
        setPatientsInvestigation(currentInvestigation && props.patients.data
            ? props.patients.data[currentInvestigation.uuid]
            : []);
    }, [currentInvestigation, props.patients.data])

    useEffect(() => {
        setCurrentInvestigation(props.investigations.currentInvestigation)
    }, [props.investigations.currentInvestigation])

    async function callbackSavePatient(patientData) {

        if (patient) {
            // An edit (SKIN-374) runs inside the reason dialog, which owns its in-flight and
            // error state: the form stays mounted, and a refusal propagates to the dialog
            // instead of collapsing into a generic error.
            await dispatch(updatePatientAction(props.investigations.currentInvestigation, patient.uuid, patientData));
            history.goBack();
            return;
        }

        try {
            setIsLoading(true);
            await dispatch(savePatientAction(props.investigations.currentInvestigation, patientData));
            setAddedPatient(true);
            setIsLoading(false);
            
        }
        catch (error) {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        if(addedPatient){
            setTimeout(() => {
                setAddedPatient(false);
            }, 3000);
            
        }
    }, [addedPatient])

    if (isLoading || props.investigations.loading || !props.investigations.currentInvestigation || props.isLoading) {
        return <Loader />;
    }
    else if (
        !props.investigations.currentInvestigation.permissions.includes(
            PERMISSION.PERSONAL_ACCESS
        )
    ) {
        history.push(ROUTE_401);
        return <Loader />;
    }

    // Editing: wait until the patient is synced into Redux before rendering the
    // form. Otherwise it mounts in create mode and redux-form keeps the empty
    // initial values even after the patient loads.
    const patientsForInvestigation = props.patients.data &&
        props.patients.data[props.investigations.currentInvestigation.uuid];
    if (uuidPatient && !patient && (props.patients.loading || !patientsForInvestigation)) {
        return <Loader />;
    }

    return (
        <AddPatientComponent
            personalFields={props.investigations.currentInvestigation.personalFields}
            keyResearcherInvestigation={
                props.investigations.currentInvestigation.keyResearcherInvestigation
            }
            investigationUuid={props.investigations.currentInvestigation.uuid}
            useV2={useV2Encryption}
            investigations={props.investigations}
            patient={patient}
            addedPatient = {addedPatient}
            error={props.patients.error}
            patientsInvestigation={patientsInvestigation}
            callbackGoToAppointment = {(uuidPatient:string) => callbackGoToAppointment(uuidPatient)}
            callbackSavePatient={(patientData: any) => callbackSavePatient(patientData)}
            callbackGoToPatient = {(uuidPatient:string) => callbackGoToPatient(uuidPatient)}
        />
    );
}

const mapStateToProps = (state: any) => {
    return {
        investigations: state.investigations, // Replace 'any' with the appropriate type for state.investigations
        patients: state.patients, // Replace 'any' with the appropriate type for state.patients
    };
};

export default connect(mapStateToProps, null)(AddPatient);
